import React, { useState, useEffect } from 'react';
import '../../CSS/cardStudio.css';
import { TextField, Typography, Slider, Box, Grid, FormControlLabel, RadioGroup, Button, Radio, FormLabel, Switch } from '@mui/material';
import { useStudio } from '../../Context/StudioContext';
import { Upload, X, Image as ImageIcon } from 'lucide-react';
import { IconButton } from '@mui/material';

import ImageUploadBox from './ImageUploadBox';

const Page7Settings = () => {
    const { formData, setFormData } = useStudio();

    useEffect(() => {
        if (formData.packageType === 'Basic') {
            if (formData.showQRBank || formData.showWishlistGift || formData.sliderImage1 || formData.sliderImage2 || formData.sliderImage3) {
                setFormData(prev => ({
                    ...prev,
                    showQRBank: false,
                    showWishlistGift: false,
                    sliderImage1: '',
                    sliderImage2: '',
                    sliderImage3: ''
                }));
            }
        }
    }, [formData.packageType, formData.showQRBank, formData.showWishlistGift, formData.sliderImage1, formData.sliderImage2, formData.sliderImage3, setFormData]);

    const showQRBank = formData.showQRBank;
    const showWishlistGift = formData.showWishlistGift;

    const handleToggle = (e) => {
        const isChecked = e.target.checked;

        setFormData((prev) => ({
            ...prev,
            showQRBank: isChecked,
            bankName: isChecked ? prev.bankName : "",
            bankAccountNumber: isChecked ? prev.bankAccountNumber : "",
            bankAccountName: isChecked ? prev.bankAccountName : "",
        }));
    };

    const handleToggleWishlistGift = (e) => {
        const isChecked = e.target.checked;

        setFormData((prev) => {
            let nextGifts = prev.gifts;
            if (isChecked) {
                if (!Array.isArray(prev.gifts) || prev.gifts.length === 0 || typeof prev.gifts[0] !== 'object') {
                    nextGifts = [{ name: '', link: '' }];
                }
            }

            return {
                ...prev,
                showWishlistGift: isChecked,
                gifts: nextGifts,
            };
        });
    };

    const handleChange = (field) => (e) => {
        setFormData(prev => ({ ...prev, [field]: e.target.value }));
    };

    return (
        <Box sx={{ display: 'grid' }}>


            <Box sx={{ mb: 2 }}>
                <Typography variant="h6">Galeri Gambar</Typography>

                {formData.packageType === 'Basic' && (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1, mb: 1 }}>
                        <X size={16} color="#701d1dff" />
                        <Typography variant="body2" color="#701d1dff">Fungsi ini hanya tersedia untuk pakej Standard dan Premium</Typography>
                    </Box>
                )}

                <Typography mb={2} color="text.secondary" variant="body2">Format gambar adalah 1:1 (Max Size 2MB)</Typography>
                <Grid container spacing={2}>
                    <Grid item xs={4}>
                        <ImageUploadBox
                            disabled={formData.packageType === 'Basic'}
                            value={formData.sliderImage1}
                            onChange={(url, file) => setFormData(prev => ({ ...prev, sliderImage1: url, sliderImage1File: file }))}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <ImageUploadBox
                            disabled={formData.packageType === 'Basic'}
                            value={formData.sliderImage2}
                            onChange={(url, file) => setFormData(prev => ({ ...prev, sliderImage2: url, sliderImage2File: file }))}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <ImageUploadBox
                            disabled={formData.packageType === 'Basic'}
                            value={formData.sliderImage3}
                            onChange={(url, file) => setFormData(prev => ({ ...prev, sliderImage3: url, sliderImage3File: file }))}
                        />
                    </Grid>
                </Grid>
            </Box>

            <Typography mb={2} mt={2} variant="h6">QR Bank & Hadiah</Typography>

            {(formData.packageType === 'Basic' || formData.packageType === 'Standard') && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <X size={16} color="#701d1dff" />
                    <Typography variant="body2" color="#701d1dff">Fungsi ini hanya tersedia untuk pakej Premium</Typography>
                </Box>
            )}

            <FormControlLabel
                sx={{ mt: 2 }}
                label="Papar QR Bank"
                disabled={formData.packageType === 'Basic' || formData.packageType === 'Standard'}
                control={
                    <Switch
                        checked={showQRBank}
                        onChange={handleToggle}
                        sx={{
                            '& .MuiSwitch-switchBase.Mui-checked': {
                                color: '#68D2D2',
                            },
                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                backgroundColor: '#68d2d294',
                            },
                        }}
                    />
                }
            />

            {showQRBank && (
                <Box sx={{ mt: 1 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                        {/* Image — fixed small size on all screens */}
                        <Box sx={{ flexShrink: 0, width: 130 }}>
                            <ImageUploadBox
                                label="QR Bank / DuitNow"
                                value={formData.bankQRImage}
                                onChange={(url, file) => setFormData(prev => ({ ...prev, bankQRImage: url, bankQRImageFile: file }))}
                            />
                        </Box>

                        {/* Fields — take remaining space */}
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                            <TextField
                                label="Nama Bank"
                                fullWidth

                                value={formData.bankName}
                                onChange={handleChange('bankName')}
                                margin="dense"
                                InputLabelProps={{ shrink: true }}
                                placeholder="Contoh: Maybank, CIMB, TNG"
                            />

                            <TextField
                                label="Nombor Akaun"
                                fullWidth

                                value={formData.bankAccountNumber}
                                onChange={handleChange('bankAccountNumber')}
                                margin="dense"
                                InputLabelProps={{ shrink: true }}
                                placeholder="Contoh: 123456789"
                            />
                            <TextField
                                label="Nama Pemegang Akaun"
                                fullWidth

                                value={formData.bankAccountName}
                                onChange={handleChange('bankAccountName')}
                                margin="dense"
                                InputLabelProps={{ shrink: true }}
                                placeholder="Nama Penuh"
                            />
                        </Box>
                    </Box>
                </Box>
            )}

            <FormControlLabel
                sx={{ mt: 2 }}
                label="Papar Hadiah Pilihan"
                disabled={formData.packageType === 'Basic' || formData.packageType === 'Standard'}
                control={
                    <Switch
                        checked={showWishlistGift}
                        onChange={handleToggleWishlistGift}
                        sx={{
                            '& .MuiSwitch-switchBase.Mui-checked': {
                                color: '#68D2D2',
                            },
                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                backgroundColor: '#68d2d294',
                            },
                        }}
                    />
                }
            />

            {showWishlistGift && (
                <Box sx={{ mt: 1 }}>
                    <Grid item xs={12}>
                        <TextField
                            label="Alamat Penghantaran (Untuk Hadiah)"
                            fullWidth
                            multiline
                            minRows={2}
                            value={formData.brideAddress || ''}
                            onChange={handleChange('brideAddress')}
                            margin="dense"
                            InputLabelProps={{ shrink: true }}
                            placeholder="Alamat penuh pengantin"
                        />
                    </Grid>
                    {(formData.gifts || []).map((gift, index) => (
                        <Box key={index} sx={{ mt: 2, mb: 2, p: 2, border: '1px solid #eee', borderRadius: '8px' }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Typography variant="subtitle2">Hadiah {index + 1}</Typography>
                                    {gift.isReserved && (
                                        <Box
                                            sx={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: 0.5,
                                                px: 1,
                                                py: 0.3,
                                                borderRadius: '999px',
                                                backgroundColor: 'rgba(76,175,80,0.1)',
                                                color: '#2e7d32',
                                                fontSize: 11,
                                                fontWeight: 600,
                                            }}
                                        >
                                            ✓ Ditempah
                                        </Box>
                                    )}
                                </Box>
                                <IconButton
                                    size="small"
                                    color="error"
                                    onClick={() => {
                                        const newGifts = [...(formData.gifts || [])];
                                        newGifts.splice(index, 1);
                                        setFormData(prev => ({ ...prev, gifts: newGifts }));
                                    }}
                                    disabled={formData.gifts.length === 1 || gift.isReserved}
                                    title={gift.isReserved ? 'Hadiah ini telah ditempah dan tidak boleh dipadam' : ''}
                                >
                                    <X size={16} />
                                </IconButton>
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2.5 }}>
                                {/* Image — fixed small size on all screens */}
                                <Box sx={{ flexShrink: 0, width: 92 }}>
                                    <ImageUploadBox
                                        value={gift.giftImage || ''}
                                        disabled={gift.isReserved}
                                        onChange={(url, file) => {
                                            const newGifts = [...(formData.gifts || [])];
                                            newGifts[index] = {
                                                ...newGifts[index],
                                                giftImage: url,
                                                imageFile: file,
                                            };
                                            setFormData(prev => ({ ...prev, gifts: newGifts }));
                                        }}
                                    />
                                </Box>

                                {/* Fields — take remaining space */}
                                <Box sx={{ flex: 1, minWidth: 0 }}>
                                    <TextField
                                        label="Nama Item"
                                        fullWidth
                                        size="small"
                                        value={gift.giftName || ''}
                                        onChange={(e) => {
                                            const newGifts = [...(formData.gifts || [])];
                                            newGifts[index] = {
                                                ...newGifts[index],
                                                giftName: e.target.value,
                                            };
                                            setFormData(prev => ({ ...prev, gifts: newGifts }));
                                        }}
                                        placeholder="Mini Vacuum Philips"
                                        InputLabelProps={{ shrink: true }}
                                        sx={{ mb: 2 }}
                                    />
                                    <TextField
                                        label="Pautan Pembelian (Shopee dll)"
                                        fullWidth
                                        size="small"
                                        value={gift.giftLink || ''}
                                        onChange={(e) => {
                                            const newGifts = [...(formData.gifts || [])];
                                            newGifts[index] = {
                                                ...newGifts[index],
                                                giftLink: e.target.value,
                                            };
                                            setFormData(prev => ({ ...prev, gifts: newGifts }));
                                        }}
                                        placeholder="https://shopee.com.my/..."
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Box>
                            </Box>

                        </Box>
                    ))}

                    <Button
                        variant="outlined"
                        onClick={() => {
                            setFormData(prev => ({
                                ...prev,
                                gifts: [...(prev.gifts || []), { giftName: '', giftLink: '', giftImage: '' }]
                            }));
                        }}
                        sx={{ textTransform: 'none', borderRadius: '20px', fontWeight: '600', color: '#68D2D2', border: '1px solid #68D2D2' }}
                    >
                        + Tambah Hadiah
                    </Button>
                </Box>
            )}



        </Box>


    );
};



export default Page7Settings;
